import { useState } from "react";

// helpers
import { setNotPickedUp } from "../common/helper";

// components
import { Button } from "shared/components/bulma/button";

const SetNotPickedUp = ({ customer, box, onClick }) => {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        if (!window.confirm(`Are you sure you want to set the box as Not Picked Up?`)) {
            return;
        }

        setLoading(true);
        await setNotPickedUp({ customer, box });
        setLoading(false);
        if (onClick) { onClick(); }
    }

    if (box.status === "partially_returned") {
        return null;
    }

    return (
        <Button className={`is-small is-danger is-outlined ${loading ? 'is-loading' : ''}`} onClick={handleClick} >
            <span className="icon">
                <i className="fas fa-trash"></i>
            </span>
            <span>Not Picked Up</span>
        </Button>
    );
}

export { SetNotPickedUp };
